;(function($) {
$.fn.ajaxKosik=function(opts) {
	if (!this.length) {
		return this;
	}
	if (this.length>1) {
		this.each(function() {
			$(this).ajaxKosik(opts);
		});
		return this;
	}

	var originator;	
	var receivedData;

	if (!(this.is("form")) && !(this.is("a")) && !(this.is("button")) && !(this.is("[data-url]"))) {
		if (console && console.log) console.log("Funkci $.ajaxKosik je nutno volat na <form> nebo <a> nebo <button> (s data-url) element!");
		return this;
	}
	var _this=this;
	var mode="a";
	if (this.is("form")) {
		mode="form";
	}
	
	if (mode=="form") {
		this.attr("accept-charset","utf-8");
	}

	var processSubmitConditions = function() {
		if (!$.ajaxKosikSubmitConditions) return true;
		var ok = true;
		$.each($.ajaxKosikSubmitConditions, function() {
			var result = this.call(_this);
			if (result === false) {
				ok = false;
			}
		});
		return ok;
	}
	
	var okHandler=function(data) {
		var _this=this;
		receivedData = data;
		var $dialog=$("<div class='ajaxkosik-popup' id='ajaxkosik-dialog'></div>").css({
			"position":"fixed",
			"left":"50%",
			"top":"50%",
			"background-color":data.setup.colorBg
		}).html("<a href='#' class='ajaxkosik-closer' title='"+data.text.zavrit+"'></a><div class='in'></div></form>");
		var $overlay=$("<div id='ajaxkosik-overlay'></div>").css({
			"position":"fixed",
			"left":"0px",
			"top":"0px",
			"width":"100%",
			"height":"100%",
			"background-color":"rgba(0,0,0,0.6)",
			"z-index":"999"
		}).click(function() {
			cancel.call(_this);
		});
		if (navigator.userAgent.match(/MSIE (6|7|8)/)) {
			$overlay.addClass("ajaxkosik-overlay-fallback");
		}		
		
		$dialog.find(".ajaxkosik-closer").click(function() {
			cancel.call(_this);
			return false;
		});
		$(document.body).on("keydown.aniEshopKosik",function(e) {
			if (e.keyCode!=27) return;
			sendlinkCancel();
		});	
		
		$(document.body).append($overlay.hide().fadeIn(200)).append($dialog);
		$dialog.css("opacity",0.1).hide();

		var measureDialogHeight = function() {
			var prevMaxHeight = $dialog.css('max-height');
			$dialog.css('max-height', 'none');
			var dh=$dialog.outerHeight(false);
			$dialog.css('max-height', prevMaxHeight);
			return dh;
		}

		var positionKosik = function() {
			var wh=$(window).height();
			var verticalMargin = wh * 0.1; // dialog is 90% of vh
			$(".ajaxkosik-crossselling").show();
			var dh = measureDialogHeight();
			if (dh>wh-verticalMargin) {
				var $kp=$dialog.find(".ajaxkosik-produkty");
				var mh = (wh-verticalMargin-(dh-$kp.outerHeight(true)));
				if (mh < 150) {
					$(".ajaxkosik-crossselling").hide();
					dh = measureDialogHeight();
					mh = (wh-verticalMargin-(dh-$kp.outerHeight(true)));
				}
				$kp.css({
					"max-height": (mh+"px"),
					"overflow":"auto"
				});
			}
			$dialog.css({
				"margin-top":(-1*$dialog.outerHeight(false)*0.5)
			});
			$dialog.css({
				"margin-left":(-1*$dialog.outerWidth(false)*0.5)
			});			
			if (wh <= 600) { // Máme responzivní verzi a v safari je problém s pozicováním
				$dialog.css("top", $(window).scrollTop()+20);
			}
		}

		window.setTimeout(function() {
			$dialog.hide().fadeTo(200,1);
			$dialog.find(".ajaxkosik-closer").show();		
			positionKosik();	
		},100);		

		window.setTimeout(positionKosik, 400);
		window.setTimeout(positionKosik, 1000);
		window.setTimeout(positionKosik, 2000);
		window.setTimeout(positionKosik, 3000);
		window.setTimeout(positionKosik, 4000);
		$(window).off("resize.ajaxkosik").on("resize.ajaxkosik", positionKosik);
		
		var $body=$dialog.find(".in");
		
		$body.append("<div class='ajaxkosik-nadpis'>"+data.text.nadpis+"</div>");
		if (data.zprava) $body.append("<div class='ajaxkosik-zprava' style=''>"+data.zprava+"</div>");
		
		if (data["custom-html-top"]) {
			$body.append($("<div class='ajaxkosik-text ajaxkosik-custom-html-top'></div>").html(data["custom-html-top"]));
		}		

		if (data["say"]) {
			$body.append($("<div class='ajaxkosik-text ajaxkosik-say'></div>").html(data["say"]));
		}

		var $produkty=$("<div class='ajaxkosik-produkty'>");
		
		var i;
		for (i=0;i<data.produkty.length;i++) {
			var prod=data.produkty[i];
			var $radek=$("<div class='ajaxkosik-radek'></div>");
            if (prod.obrazek) {
                $radek.append($("<div class='ajaxkosik-obrazek'></div>").append($(""+prod.obrazek)));
            }
            var $stred=$("<div class='ajaxkosik-stred'></div>");
            $radek.append($stred);
            $stred.append($("<div class='ajaxkosik-nazev'><a href='"+prod.odkaz+"'>"+prod.nazev+"</div>"));
            if (prod.detail) $stred.append($("<div class='ajaxkosik-detail'>"+prod.detail+"</div>"));
            if (prod.kod) $stred.append($("<div class='ajaxkosik-kod'>"+prod.kod+"</div>"));

            $dopravacenawrapper = $("<div class='ajaxkosik-doprava-cena-wrapper'></div>");
            $cenawrapper = $("<div class='ajaxkosik-cena-wrapper'></div>");

            $cenawrapper.append($("<div class='ajaxkosik-pocet'>"+prod.pocet+" &times;</div>"));
            $cenawrapper.append($("<div class='ajaxkosik-cena'>"+prod.cena_format+"</div>"));

            $dopravacenawrapper.append($cenawrapper);
            $dopravacenawrapper.append($("<div class='ajaxkosik-doprava-zdarma'>"+prod.doprava_zdarma+"</div>"));
            $radek.append($dopravacenawrapper);

            $radek.append($("<div class='cleaner'></div>"));
            $produkty.append($radek);
        }
		$body.append($produkty);
		
		if (data.produkty.length==0) {
			$body.append($("<div class='ajaxkosik-text'></div>").html(data.text.prazdny));
		}
		
		if (data.poplatky>0 && data.setup.zobrazDopravu) {
			var $poplatky=$("<div class='ajaxkosik-poplatky'></div>");
			$poplatky.append($("<div class='ajaxkosik-poplatky-nazev'>"+data.text.poplatky+"</div>"));
			$poplatky.append($("<div class='ajaxkosik-poplatky-cena'>"+data.poplatky_format+"</div>"));
			$body.append($poplatky);
		}
		
		if (data.remainingDoprava) {
			var text = data.text.remainingDoprava.replace("%cena%", data.remainingDoprava);
			var $remaining=$("<div class='ajaxkosik-remaining ajaxkosik-remaining-doprava'></div>").html(text);
			$body.append($remaining);
		}

		if (data.remainingPlatba) {
			var text = data.text.remainingPlatba.replace("%cena%", data.remainingPlatba);
			var $remaining=$("<div class='ajaxkosik-remaining ajaxkosik-remaining-platba'></div>").html(text);
			$body.append($remaining);
		}

		if (data.dopravaZdarma) {
			var text = data.text.dopravaZdarma.replace("%limit%", data.limitDoprava);
			var $remaining=$("<div class='ajaxkosik-zdarma ajaxkosik-zdarma-doprava'></div>").html(text);
			$body.append($remaining);
		}

		if (data.platbaZdarma) {
			var text = data.text.platbaZdarma.replace("%limit%", data.limitPlatba);
			var $remaining=$("<div class='ajaxkosik-zdarma ajaxkosik-zdarma-platba'></div>").html(text);
			$body.append($remaining);
		}

		if (data.cena>0) {
			var $celkem=$("<div class='ajaxkosik-total'></div>");
			$celkem.append($("<div class='ajaxkosik-total-nazev'>"+data.text.celkem+"</div>"));
			$celkem.append($("<div class='ajaxkosik-total-cena'>"+(data.setup.zobrazDopravu?data.cena_format:data.cena_produkty_format)+"</div>"));
			$body.append($celkem);
		}

		if (data["custom-html"]) {
			$body.append($("<div class='ajaxkosik-text ajaxkosik-custom-html'></div>").html(data["custom-html"]));
		}		

		if (data["crossselling"]) {
			$body.append($("<div></div>").html(data["crossselling"]));
		}
				
		var opts=$(this).data("ajaxKosik");

		if (!opts) {
			opts = {};
		}

		opts=$.extend({
			"classButtons": "ajaxkosik-buttons",
			"classButtonZpet": "ajaxkosik-button-zpet",
			"classButtonKosik": "ajaxkosik-button-kosik",
			"classButtonPokracovat": "ajaxkosik-button-pokracovat"
		},opts);

		var $buttons=$("<div class='" + opts.classButtons + "'></div>");
		$buttons.append($("<a class='" + opts.classButtonZpet + "' href='#'>"+data.text.cancel+"</a>").click(cancel));
		if (data.pokracovat) {
			$buttons.append($("<a class='" + opts.classButtonPokracovat + "' style='background-color:"+(data.setup.colorButton)+"; color:"+(data.setup.colorText)+"' href='"+data.pokracovat+"'>"+data.text.pokracovat+"</a>"));
		} else {
			$buttons.append($("<a class='" + opts.classButtonPokracovat + "' style='background-color:"+(data.setup.colorButton)+"; color:"+(data.setup.colorText)+"' href='eshop-objednavka-1.html'>"+data.text.pokracovat+"</a>"));
			$buttons.append($("<a class='" + opts.classButtonKosik + "' href='eshop-kosik.html'>"+data.text.kosik+"</a>"));			
		}
		
		$body.append($buttons);

		if (data.script) {
			var scr = document.createElement("script");
			scr.innerHTML = data.script;
			scr.type = "text/javascript";
			$body[0].appendChild(scr);
		}

		
		if (window.opti && window._optiConfig && window._optiConfig.bindEvents) {
			var identifikator=data.zprava;
			var b=$("<div>"+data.zprava+"</div>").find("b, strong");
			if (b.length) identifikator=b.html();
			window.opti._trackEvent("kosik", "pridat", identifikator);
			window.opti._trackPageview("eshop-kosik.html");
		}
		
		if (data.update && data.update.length) {
			window.setTimeout(function() {
				$.each(data.update,function(i,r) {
					$(r.selector).html(r.value);
				});
			},400);
		}
		
		if (loadingObject) {
			var opts=$(_this).data("ajaxKosik");		
			window.setTimeout(function() {	
				if (opts.loadingText) {		
					if (loadingObject.is("input")) loadingObject.val(loadingOriginalText);
						else loadingObject.html(loadingOriginalText);
				}
				loadingObject.removeClass(opts.loadingClass);							
			},400);
		}
		
		if (opts) {
			if (opts.onShow && $.isFunction(opts.onShow)) {
				opts.onShow.call(this, receivedData);
			}			
		}

		if ($(window).height() <= 550) {
			$dialog.css("top", $(window).scrollTop()*1+20);
			$dialog.addClass("init-with-small-screen");
		}
	}
	
	var cancel = function() {
		$(document.body).off(".aniEshopKosik");
		$("#ajaxkosik-dialog").fadeOut(300,function() {
			$(this).remove();
			$("#ajaxkosik-overlay").fadeOut(200,function() { 
				$(this).remove();
			});
		});
		var opts=$(this).data("ajaxKosik");
		if (opts && opts.onClose && $.isFunction(opts.onClose)) {
			opts.onClose.call(this, receivedData);
		}		
		return false;
	}
	

	var submitHandler=function(e) {
		e.preventDefault();

		if ($.ajaxKosikTimedLock) return false;
		lockWithTiming();

		if (!processSubmitConditions()) {
			return false;
		}

		if ($("#ajaxkosik-dialog").length) {
			cancel.call(originator);
		}
		originator = this;

		var _this=this;
		$(this).ajaxSubmit({
			"dataType":"json",
			"data":{"ajaxeshop":"1"},
			"success":function(a,b,c,d) {
				okHandler.call(_this,a,b,c,d);
			},
			"method":"POST",
			"error":function(a, b, c) {
				console.log('Ajaxový košík selhal.', a, b, c);
				window.setTimeout(function() {
					window.location="eshop-kosik.html";					
				}, 100);
			}
		});
		
		var opts=$(this).data("ajaxKosik");
		
		if (opts.loadingText!==false || opts.loadingClass!==false) {
			var $a=$(this);
			if (opts.loadingTarget) {
				$a=$a.find(opts.loadingTarget);
			}
			if (opts.loadingText !== false) {
				if ($a.is("input")) {
					loadingOriginalText=$a.val();
					$a.val(opts.loadingText);
				} else {
					loadingOriginalText=$a.html();
					$a.html(opts.loadingText);
				}
			}
			loadingObject=$a;
			$a.addClass(opts.loadingClass);			
		}

		if (opts.onInit && $.isFunction(opts.onInit)) {
			opts.onInit.call(this);
		}
	}


	
	var clickHandler=function(e) {

		if ($.ajaxKosikTimedLock) return false;
		lockWithTiming();

		if (!processSubmitConditions()) {
			return false;
		}

		if ($("#ajaxkosik-dialog").length) {
			cancel.call(originator);
		}
		originator = this;

		var $a=$(this);
		var target=$a.attr("href");
		if (!target && $a.attr("data-url")) {
			target = $a.attr("data-url");
		}
		if (!target || target=="#") target="eshop-kosik.html"; 
		var _this=this;
		$.ajax(target,{
			"dataType":"json",
			"data":{"ajaxeshop":"1"},
			"success":function(a,b,c,d) {
				okHandler.call(_this,a,b,c,d);
			},
			"type":"POST",
			"error":function() {
				console.log('Ajaxový košík selhal.', a, b, c);
				window.setTimeout(function() {
					window.location="eshop-kosik.html";					
				}, 100);

			}
		});

		var opts=$a.data("ajaxKosik");
		if (opts.onInit && $.isFunction(opts.onInit)) {
			opts.onInit.call(this);
		}

		var opts=$a.data("ajaxKosik");
		if (opts.loadingText !== false || opts.loadingClass!==false) {
			if (opts.loadingText !== false) {
				loadingOriginalText=$a.html();
				loadingObject=$a;
				if (opts.loadingTarget) {
					$a=$a.find(opts.loadingTarget);
				}			
				$a.html(opts.loadingText);
			}
			$a.addClass(opts.loadingClass);
			
		}
		return false;
	}	
	
	var lockWithTiming = function() {
		$.ajaxKosikTimedLock = true;
		window.setTimeout(function() {
			$.ajaxKosikTimedLock = false;
		}, 500);
	};

	if (mode=="form") {
		this.submit(submitHandler);
	} else {
		this.click(clickHandler);
	}
	
	opts=$.extend({
		"loadingText":false,
		"loadingTarget":false,
		"loadingClass":false,
		"onInit":false,
		"onShow":false,
		"onClose":false,
		"classButtons": "ajaxkosik-buttons",
		"classButtonZpet": "ajaxkosik-button-zpet",
		"classButtonKosik": "ajaxkosik-button-kosik",
		"classButtonPokracovat": "ajaxkosik-button-pokracovat"
	},opts);
	
	this.data("ajaxKosik",opts);
	
	var loadingObject=null;
	var loadingOriginalText="";

	$.ajaxKosikTimedLock = false;
	
	return this;
}

$.ajaxKosikAddSubmitCondition = function(fn) {
	if (!$.ajaxKosikSubmitConditions) {
		$.ajaxKosikSubmitConditions = [];
	}

	$.ajaxKosikSubmitConditions.push(fn);
}

$.loadNextEshopPage=function(url, callbackSuccess, callbackError) {
	if (window.loadNextEshopPageLocked) {
		return false;
	}
	if (!callbackSuccess) callbackSuccess=function() {};
	$.ajax(url,{
		"method": "get",
		"dataType": "html",
		"success": function(response) {
			if (window.loadNextEshopPageLocked) {
				window.clearTimeout(window.loadNextEshopPageLocked);
				window.loadNextEshopPageLocked = null;
			}
			callbackSuccess(response)
		},
		"error":callbackError
	});
	window.loadNextEshopPageLocked = window.setTimeout(function() {
		window.loadNextEshopPageLocked = null;
	}, 5000);
}

$.fn.ajaxNextEshopPage=function(params) {
	if (!this.length) return this;
	var defaults={
		"loadingText":false,
		"loadingClass":false,
		"loadingTarget":false,
		"containerId":false,
		"buttonId":false,
		"buttonWithHtml":false,
		"hideOnLastPage":false,
		"alsoRefresh":[],
		"historyPushState": false,
		"processResponse": false,
		"success":false,
		"error":false
	};
	params=$.extend(defaults,params);

	if (!params.buttonId) {
		if (console && console.log) console.log("Missing buttonId in ajaxNextEshopPage()");
		return false;
	}
	if (!params.containerId) {
		if (console && console.log) console.log("Missing containerId in ajaxNextEshopPage()");
		return false;
	}

	if (!this.is("a[href]")) {
		if (console && console.log) console.log("ajaxNextEshopPage() can be called only on a[href] element!");
	}
	
	function error(a,b,c) {
		loadingStopped();
		if (params.error) {
			params.error.call($this,a,b,c);
		}
	}

	function loadingStarted() {
		var target=params.loadingTarget;
		if (target===false) target=$this;
		var $target=$(target);
		if (params.loadingText!==false) {
			$target.data("ajaxload-orig-text",$target.html());
			$target.html(params.loadingText);
		}
		if (params.loadingClass!==false) $target.addClass(params.loadingClass);
	}

	function loadingStopped() {
		var target=params.loadingTarget;
		if (target===false) target=$this;
		var $target=$(target);
		if (params.loadingText!==false && !params.buttonWithHtml) {
			var orig=$target.data("ajaxload-orig-text");
			if (typeof orig != "undefined") {
				$target.html(orig);
			}
		}
		if (params.loadingClass!==false) $target.removeClass(params.loadingClass);
	}

	function loadingLastPage() {
		$this.hide();	
		if (params.hideOnLastPage) {
			$(params.hideOnLastPage).hide();
		}
	}

	var $this=$(this);
	var $containerOnThisPage=$("#"+params["containerId"]);
	if ($containerOnThisPage.length!=1) {
		return;
	}

	this.addClass("ajax-eshop-next-page").click(function() {
		var href=$this.attr("href");
		$.loadNextEshopPage(href, function(response) {
			var $response=$(response);

			if (params.processResponse) {
				var ret = params.processResponse.call(this, $response);
				if (ret) {
					$response = ret;
				}
			}

			var $container=$response.find("#"+params["containerId"]);
			var $button=$response.find("#"+params["buttonId"]);
			if ($container.length!=1) {
				if (console && console.log) console.log("Ajax downloading next page - containerId is wrong.", $container);
				error();
				return;
			}
			if ($button.length!=1) {
				loadingLastPage();
			} else {
				$this.attr("href",$button.attr("href"));
				if (params.buttonWithHtml) {
					$this.html($button.html());
				}
				loadingStopped();
			}
			var payload=$container.html();
			$containerOnThisPage.append(payload);

			if (params.alsoRefresh.length) {
				$.each(params.alsoRefresh,function(i,selector) {
					var $target=$(selector);
					if ($target.length==1) {
						var $source=$response.find(selector);
						if ($source.length==1) {
							$target.html($source.html());
						}
					}
				});
			}

			if (params.historyPushState) {
				if (href && href.match(/strana=\d/)) {
					var loadedStranaMatch = href.match(/strana=(\d+)/);
					var loadedStrana = loadedStranaMatch[1];
					window.history.pushState({
						eshopStrana: loadedStrana,
						eshopHref: href,
					}, '', href);
				}
			}

			if (params.success) {
				params.success.call($this,response);
			}			

		},function(a,b,c) {
			if (console && console.log) console.log("Failed ajax downloading of next page.",a,b,c);
			error(a,b,c);
			return;
		});

		loadingStarted();		
		return false;
	});

	return this;
}
	

})(jQuery);